import { message } from "antd";

export const logout = (navigate, setUser) => {
  message.success("Logged out successfully");
  localStorage.clear();
  setUser("public");
  navigate("/login");
};
